// extracted by mini-css-extract-plugin
export default {"cardContainer":"AuditionsSection_cardContainer__YvmFZ"};